import React from "react";
import WalletTransactionStore from "../../../stores/wallet/wallet-transaction-store";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../components/fonts/font-props";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import Currency from "../../../../../components/currency/currency";
import { WALLET_TRANSACTION_STATUS_ENUM } from "../../../../../services/api/wallet-service";


interface IBalanceAfterTransactionProps {
    transaction: WalletTransactionStore
}

const shouldShowBalance = (status: WALLET_TRANSACTION_STATUS_ENUM): boolean => {
    return [
        WALLET_TRANSACTION_STATUS_ENUM.STATUS_SUCCEEDED,
        WALLET_TRANSACTION_STATUS_ENUM.STATUS_PENDING
    ].includes(status);
}

const BalanceAfterTransaction: React.FC<IBalanceAfterTransactionProps> = ({ transaction }) => {
    return (
        <FontBody2
            variant={FONT_VARIANT.BOLD}
            color={Number(transaction.balanceAfter) === 0 ? FONT_COLOR.ACCENT3 : FONT_COLOR.PRIMARY3}
        >
            {shouldShowBalance(transaction.status) &&
                <Currency
                    amount={Number(transaction.balanceAfter)}
                    currencyCode={transaction.currency}
                    useNative={true}
                />
            }
        </FontBody2>
    )
}

export default BalanceAfterTransaction;